﻿﻿import { IMatchHistoryRecipient } from './match-history-recipient';

export interface IUpdateMatchHistoryDeadline {
    list: IMatchHistoryRecipient[];
    matchHistoryType: number;
    clusterId: number;
    deadlineDateTime: string;
}
